import { setDoc, doc, collection, addDoc } from "firebase/firestore/lite";
import { isDesktop, isMobileOnly, isTablet } from "react-device-detect";

export async function createUserFromProviderInDatabase(db, user, formikStore) {
  try {
    if (user) {
      let photoURL = null;
      let avatarURL = null;
      let providerId = null;
      let email = null;
      let isAnonymous = false;
      if (user.isAnonymous) {
        isAnonymous = true;
      }
      if (user.providerData && user.providerData[0]) {
        avatarURL = user.providerData[0].photoURL;
        providerId = user.providerData[0].providerId;
        email = user.providerData[0].email;
        if (providerId === "facebook.com" && avatarURL) {
          photoURL = `${avatarURL}?type=large`;
        } else {
          photoURL = avatarURL;
        }
      }

      const newUserData = {
        handle: user.displayName,
        isAnonymous,
        createdAt: new Date().toISOString(),
        userId: user.uid,
        photoURL,
        providerId,
        projectId: formikStore.values.projectId,
        referrer: formikStore.values.referrer,
        utm_id: formikStore.values.utm_id,
        declarationOfConsent:
          localStorage.getItem("declarationOfConsent") === "true"
            ? true
            : false,
        device: isMobileOnly
          ? "mobile"
          : isTablet
            ? "tablet"
            : isDesktop
              ? "desktop"
              : "other",
      };
      if (formikStore.values?.utm_id && formikStore.values?.utm_id !== "") {
        newUserData.utm_id = formikStore.values?.utm_id;
      }

      if (formikStore.values?.mode && formikStore.values?.mode !== "") {
        newUserData.mode = formikStore.values?.mode;
      }

      await setDoc(doc(db, "users", user.uid), newUserData).then(() => {
        localStorage.removeItem("declarationOfConsent");
      });
      await setDoc(doc(db, "users", user.uid, "Private", user.uid), {
        email,
        userId: user.uid,
      });
      const visitHistoryRef = collection(
        db,
        "users",
        user.uid,
        "activityLogbook"
      );
      const now = new Date().getTime();
      const visitData = {
        userId: user.uid,
        projectId: formikStore.values.projectId || null,
        timeStamp: now,
        createdAt: new Date().toISOString(),
        url: window.location.href,
        referrer: formikStore.values.referrer,
        utm_id: formikStore.values.utm_id,

        device: isMobileOnly
          ? "mobile"
          : isTablet
            ? "tablet"
            : isDesktop
              ? "desktop"
              : "other",
      };
      await addDoc(visitHistoryRef, visitData);
    }
  } catch (error) {
    throw new Error(error, "error in createUserFromProviderInDatabase");
  }
}
